export const manageError = (error) => {
    if (error){
        const finalErr =  error.map(gerror => {
            const err = gerror?.extensions?.exception?.errors[0]?.message;
            if (err.includes("be unique")) {
                return {message: "Ya existe un registro con este valor", field: err.split(" ")[0]}
            }else {
                return err;
            }
        });
        return finalErr;
    }
    return null;
    };